// @flow
import * as React from 'react';

import { localize } from '@ta/common.i18n';
import type { SuggestedFollowee } from '@ta/social.member-types';

import FolloweeCard from './FolloweeCard';

import styles from './FollowBlock.less';

/** A pretty list of followee cards */

type Props = {
  suggestedFollowees: SuggestedFollowee[],
};

const FollowBlock = ({ suggestedFollowees }: Props) => (
  <React.Fragment>
    <div className="ui_header h3">
      {/*  Who to follow on TripAdvisor */}
      {localize('social_home_right_rail_follow_title')}
    </div>
    <div className={styles.follow_candidates}>
      {suggestedFollowees.map(candidate => (
        <FolloweeCard
          key={candidate.userProfile.userId}
          member={candidate.userProfile}
          memberInfo={candidate.info}
        />
      ))}
    </div>
  </React.Fragment>
);

export default FollowBlock;
